"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.loaderTypes = exports.loaderColours = exports.loaderSizes = exports.loaderTextVariants = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _classnames = _interopRequireDefault(require("classnames"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _reactLottie = _interopRequireDefault(require("react-lottie"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("../../protons/typography/Typography"));

var _vodafone_loader_static = _interopRequireDefault(require("./vodafone_loader_static.json"));

var _vodafone_loader_semiDynamic = _interopRequireDefault(require("./vodafone_loader_semi-dynamic.json"));

var _vodafone_loader_dynamic = _interopRequireDefault(require("./vodafone_loader_dynamic.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    loader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      '& img': {
        width: theme.spacing(12)
      }
    },
    red: {
      '& .MuiTypography-root': {
        color: theme.palette.primary.main
      },
      '& g[opacity] path': {
        stroke: theme.palette.primary.main,
        fill: theme.palette.primary.main
      }
    },
    white: {
      '& .MuiTypography-root': {
        color: theme.palette.common.white
      },
      '& g[opacity] path': {
        stroke: theme.palette.common.white,
        fill: theme.palette.common.white
      }
    },
    grey: {
      '& .MuiTypography-root': {
        color: theme.palette.grey[500]
      },
      '& g[opacity] path': {
        stroke: theme.palette.grey[500],
        fill: theme.palette.grey[500]
      }
    }
  };
});
var mapSizes = {
  xSmall: '30px',
  small: '75px',
  medium: '150px',
  large: '300px'
};
/**
 * ** Logo - Spinner is a progress indicator that uses animation and informs the user about the status of ongoing processes. Users can navigate away from the current screen. **
 *
 * All spinners can be used on all breakpoints.
 *
 * It has 3 colors: Red, White, Grey
 *
 * It has 3 types: static, semiDynamic, dynamic
 *
 * It has 4 sizes: xSmall, small, medium, large
 *
 * It has 2 text sizes if needed: body, bodySmall
 *
 */

var Loader = function Loader(_ref) {
  var _classNames;

  var color = _ref.color,
      size = _ref.size,
      height = _ref.height,
      text = _ref.text,
      textVariant = _ref.textVariant,
      type = _ref.type;
  var styles = useStyles();

  var getLoaderType = function getLoaderType(loaderType) {
    switch (loaderType) {
      case 'static':
        return _vodafone_loader_static.default;

      case 'dynamic':
        return _vodafone_loader_dynamic.default;

      default:
        return _vodafone_loader_semiDynamic.default;
    }
  };

  var defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: getLoaderType(type)
  };
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.loader, true), _defineProperty(_classNames, styles[color], true), _classNames)),
    style: {
      minHeight: height
    }
  }, /*#__PURE__*/_react.default.createElement(_reactLottie.default, {
    options: defaultOptions,
    height: mapSizes[size],
    width: mapSizes[size]
  }), text && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    text: text,
    variant: textVariant
  }));
};

var loaderTextVariants = ['body', 'bodySmall'];
exports.loaderTextVariants = loaderTextVariants;
var loaderSizes = ['xSmall', 'small', 'medium', 'large'];
exports.loaderSizes = loaderSizes;
var loaderColours = ['red', 'white', 'grey'];
exports.loaderColours = loaderColours;
var loaderTypes = ['static', 'semiDynamic', 'dynamic'];
exports.loaderTypes = loaderTypes;
Loader.propTypes = {
  /** The size of the loader (30px, 75px, 150px, 300px) */
  size: _propTypes.default.oneOf(loaderSizes),

  /** The height of the container could be null if we want only a small loader e.g. 100vh */
  height: _propTypes.default.string,

  /** The color of the loader path */
  color: _propTypes.default.oneOf(loaderColours),

  /** The type of the loader */
  type: _propTypes.default.oneOf(loaderTypes),

  /** Additional text below loader */
  text: _propTypes.default.string,

  /** Additional text variation below loader */
  textVariant: _propTypes.default.oneOf(loaderTextVariants)
};
Loader.defaultProps = {
  size: 'medium',
  height: null,
  color: 'red',
  type: 'dynamic',
  text: null,
  textVariant: 'body'
};
var _default = Loader;
exports.default = _default;